<template>
	<b-modal v-model="isActive" has-modal-card @close="closeModal()" :can-cancel="false">
		<div class="modal-card modalCardContainer" style="
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
					">
			<header class="modal-card-head has-darker-grey-color">
				Wichtiger Hinweis
			</header>
			<section class="modal-card-body" style="padding: 0.5em; color: black">
				<P>
Sie verwenden eine veraltete Version. Ein Update ist erforderlich.
					Mit "Jetzt updaten" werden Sie abgemeldet und die neue Version wird geladen.
				</P>
			</section>
			<footer class="modal-card-foot footerContainer">
				<b-button @click="updateNow" type="is-primary">
					Jetzt updaten
				</b-button>
			</footer>
		</div>

	</b-modal>
</template>

<script>

import { mapGetters } from "vuex";
import { primePageCache } from "@/lib/versionReload";

export default {
	name: "VersionModal",
	props: ["value"],
	data() {
		return {};
	},
	mounted() { },
	computed: {
		...mapGetters({
		}),
		isActive: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	methods: {
		closeModal() {
            this.isActive = false;
        },
		async updateNow() {
			this.$store.state.focusedClientId = undefined;
			await primePageCache(window.location.href);
			this.$store
				.dispatch("logoutUser")
				.then((succ) => {
					
					this.$buefy.toast.open({
						message: "Nutzer abgemeldet!",
						type: "is-success",
						position: "is-bottom",
					});
					this.isActive = false;
					let data = true
					//this.$router.push({ name: "Login", params: { data } });
				})
				.catch((err) => {
					// The successful logout reloads the app, which is
					// the whole point of the button. A failed one has
					// to load it too: the notice cannot be dismissed,
					// so the user would be stuck on the old version.
					console.error(err);
					primePageCache("/login")
						.then(() => window.location.replace("/login"));
				});
		}
	}
}

</script>

<style scoped></style>
